import React, { useEffect, useState } from 'react';
import { apiGet, apiPost, apiPut, apiDelete } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Gift, Plus, Pencil, Trash2 } from 'lucide-react';

export default function AdminWishes() {
  const [wishes, setWishes] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editing, setEditing] = useState(null);

  const [form, setForm] = useState({
    title: '',
    description: '',
    link: ''
  });

  const load = () => {
    apiGet('/api/wishes')
      .then(r => setWishes(r.data.wishes || []))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const newWish = () => {
    setEditing(null);
    setForm({
      title: '',
      description: '',
      link: ''
    });
  };

  const editWish = (wish) => {
    setEditing(wish.id);

    setForm({
      title: wish.title || '',
      description: wish.description || '',
      link: wish.link || ''
    });
  };

  const save = async () => {
    if (editing) {
      await apiPut(`/api/wishes/${editing}`, form);
    } else {
      await apiPost('/api/wishes', form);
    }

    newWish();
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('Slet dette ønske?')) return;

    await apiDelete(`/api/wishes/${id}`);
    load();
  };

  return (
    <div className="max-w-6xl mx-auto animate-fade-in">

      <div className="flex justify-between items-center mb-8">

        <div>
          <h1 className="text-2xl font-semibold text-slate-50">
            Ønskeliste
          </h1>

          <p className="text-slate-400 text-sm">
            Administrér fødselsdagsønsker.
          </p>
        </div>

        <Button onClick={newWish}>
          <Plus className="w-4 h-4 mr-2"/>
          Tilføj ønske
        </Button>

      </div>

      <div className="grid lg:grid-cols-2 gap-8">

        <div className="space-y-4">

          {loading ? "Indlæser..." :

            wishes.map(w => (

              <div
                key={w.id}
                className="bg-slate-800/40 border border-slate-700 rounded-xl p-5"
              >

                <div className="flex justify-between">

                  <div>

                    <h3 className="text-slate-100 font-medium">
                      {w.title}
                    </h3>

                    <p className="text-slate-400 text-sm mt-2">
                      {w.description}
                    </p>

                    {w.link && (
                      <a
                        href={w.link}
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-400 text-xs mt-3 block"
                      >
                        {w.link}
                      </a>
                    )}

                  </div>

                  <div className="flex gap-2">

                    <button onClick={() => editWish(w)}>
                      <Pencil className="w-4 h-4 text-amber-400"/>
                    </button>

                    <button onClick={() => remove(w.id)}>
                      <Trash2 className="w-4 h-4 text-red-400"/>
                    </button>

                  </div>

                </div>

              </div>

            ))

          }

        </div>

        <div className="bg-slate-800/40 border border-slate-700 rounded-xl p-6">

          <h2 className="text-lg text-slate-100 mb-6">
            {editing ? 'Rediger ønske' : 'Nyt ønske'}
          </h2>

          <div className="space-y-4">

            <input
              className="w-full bg-slate-900 border border-slate-700 rounded-md px-3 py-2 text-slate-100"
              placeholder="Titel"
              value={form.title}
              onChange={e=>setForm({...form,title:e.target.value})}
            />

            <textarea
              rows={4}
              className="w-full bg-slate-900 border border-slate-700 rounded-md px-3 py-2 text-slate-100"
              placeholder="Beskrivelse"
              value={form.description}
              onChange={e=>setForm({...form,description:e.target.value})}
            />

            <input
              className="w-full bg-slate-900 border border-slate-700 rounded-md px-3 py-2 text-slate-100"
              placeholder="Link"
              value={form.link}
              onChange={e=>setForm({...form,link:e.target.value})}
            />

            <Button className="w-full" onClick={save}>
              Gem ønske
            </Button>

          </div>

        </div>

      </div>

    </div>
  );
}
